import { TypographyH4 } from "@/components/typography/H4";
import { TypographyP } from "@/components/typography/P";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_navbar/home")({
  component: Home
});

function Home() {
  return (
    <div className="bg-white w-full h-screen flex flex-col items-center justify-center gap-y-6">
      <TypographyH4>Welcome to the Numerous Enterprise platform</TypographyH4>
      <TypographyP>Currently under construction.</TypographyP>
    </div>
  );
}
